import React from "react";
import "./BackpackingTrip.css";
import HimalayanBudgetTrek from "../../assets/HimalayanBudgetTrek.png";
import SoutheastAsiaExplorer from "../../assets/SoutheastAsiaExplorer.png";
import EuropeanRailJourney from "../../assets/EuropeanRailJourney.png";
import CoastalBackpackTrail from "../../assets/CoastalBackpackTrail.png";
import DesertNomadRoute from "../../assets/DesertNomadRoute.png";
import SouthAmericanAdventure from "../../assets/SouthAmericanAdventure.png";
import { useNavigate } from "react-router-dom";
const backpackingTrips = [
  {
    title: "Himalayan Budget Trek",
    image: HimalayanBudgetTrek,
    description:
      "Embark on a budget friendly Himalayan backpacking trek filled with scenic mountain trails and peaceful villages. Experience local culture, camp under starry skies, and enjoy breathtaking sunrise views on this adventurous journey.",
    link: "/tour-package-data",
  },
  {
    title: "Southeast Asia Explorer",
    image: SoutheastAsiaExplorer,
    description:
      "Travel across vibrant Southeast Asian destinations with affordable stays and local transport. Discover street food, cultural temples, lively markets, and beautiful beaches while enjoying a flexible backpacking adventure.",
    link: "/tour-package-data",
  },
  {
    title: "European Rail Journey",
    image: EuropeanRailJourney,
    description:
      "Explore iconic European cities using scenic rail routes and budget hostels. Experience historic landmarks, diverse cultures, and delicious cuisine while meeting fellow travelers during this exciting backpacking adventure.",
    link: "/tour-package-data",
  },
  {
    title: "Coastal Backpack Trail",
    image: CoastalBackpackTrail,
    description:
      "Walk along stunning coastal trails carrying your essentials and enjoying breathtaking ocean views. Camp near beaches, explore charming fishing villages, and experience freedom on this refreshing backpacking escape.",
    link: "/tour-package-data",
  },
  {
    title: "Desert Nomad Route",
    image: DesertNomadRoute,
    description:
      "Experience a raw and authentic desert backpacking trip across golden dunes and remote settlements. Discover local traditions, enjoy peaceful sunsets, and embrace simplicity while traveling light and free.",
    link: "/tour-package-data",
  },
  {
    title: "South American Adventure",
    image: SouthAmericanAdventure,
    description:
      "Backpack through vibrant South American landscapes filled with mountains and colorful towns. Enjoy affordable adventures, cultural festivals, and thrilling hikes while exploring diverse destinations on a budget.",
    link: "/tour-package-data",
  },
];

const BackpackingTrip = () => {
  const navigate=useNavigate()
  return (
    <div className="backpacking-container">
      <h2 className="backpacking-title">Backpacking Trip Packages</h2>

      <div className="backpacking-grid">
        {backpackingTrips.map((trip, index) => (
          <div
            className="backpacking-card"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.image} alt={trip.title} />
            <div className="backpacking-content">
              <h3>{trip.title}</h3>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BackpackingTrip;
